import { authService } from '../_services/';
import Swal from 'sweetalert2';
import alerts from '../_components/alerts';

export const authActions = {
    login,
    logout,
    isGestor,
    isInseminador,
    isUsuario,
    isPrefeitura,
    isAdministrador
};

function isGestor() {
    const isGestor = (JSON.parse(localStorage.getItem('user'))["tipo"] === 'G' ? true : false);
    return isGestor;
}

function isInseminador() {
    const isInseminador = (JSON.parse(localStorage.getItem('user'))["tipo"] == 'I' ? true : false);
    return isInseminador;
}

function isPrefeitura() {
    const isPrefeitura = (JSON.parse(localStorage.getItem('user'))["tipo"] == 'P' ? true : false);
    return isPrefeitura;
}

function isUsuario() {
    const isUsuario = (JSON.parse(localStorage.getItem('user'))["tipo"] == 'U' ? true : false);
    return isUsuario;
}

function isAdministrador() {
    const isAdministrador = (JSON.parse(localStorage.getItem('user'))["tipo"] == 'A' ? true : false);
    return isAdministrador;
}

function login(username, password, navigate) {
    return dispatch => {
        let apiEndpoint = 'authentication/login';
        let payload = {
            login: username,
            senha: password,
            token: 'gestorrp_fortalezatec'
        }
        alerts.waiting();
        authService.post(apiEndpoint, payload)
            .then((response) => {
                alerts.clean();
                if (response && response.data.status.retorno) {
                    var dt = new Date();
                    //adiciona 24 horas a duração do token
                    dt.setHours(dt.getHours() + 24);

                    let token = payload.login + ":" + payload.senha;
                    localStorage.setItem('user', JSON.stringify(response.data.usuario));
                    localStorage.setItem('id_user', response.data.usuario.id);
                    localStorage.setItem('token', token);
                    localStorage.setItem('auth', true);
                    localStorage.setItem('expire', dt.getTime());
                    if (navigate) {
                        navigate('/home');
                    }
                } else if (response && response.data.status.retorno === false) {
                    Swal.fire({
                        title: 'Atenção!',
                        text: response.data.status.mensagem,
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        heightAuto: false
                    });
                } else {
                    Swal.fire({
                        title: 'Erro!',
                        text: 'Login Inválido',
                        icon: 'error',
                        confirmButtonText: 'Ok',
                        heightAuto: false
                    });
                }
            })
    };
}

function logout(redirect, navigate) {
    return dispatch => {
        localStorage.removeItem('auth');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('id_user');
        localStorage.removeItem('expire');
        //dispatch(logoutUser());
        logoutUser();
        if (redirect && navigate) {
            navigate('/');
        }
        
    }
}

export function setUserDetails(user) {
    return {
        type: "LOGIN_SUCCESS",
        auth: user.auth,
        token: user.token,
        user: user.user,
        expire: user.expire
    }
}

export function logoutUser() {
    return {
        type: "LOGOUT_SUCCESS",
        auth: false,
        token: '',
        user: null,
        expire: null
    }
}